module.exports = __webpack_public_path__ + "img/logo.89504a5c.png";